<template>
  <span v-bind:class="$mq">
    {{length}} signers
  </span>
</template>

<script>
export default {
  name : 'SignerListObj',

  props : {
    obj : Object
  },

  computed : {
    length : function(){
      return this.obj["SignerEntries"].length;
    }
  }
}
</script>

<style scoped>
</style>
